export default {"src":"/_next/static/media/configure-notification.3ee92fe7.svg","height":54,"width":87};